// extracted by mini-css-extract-plugin
module.exports = {"liveBadge":"LiveBadge_liveBadge__D167_","liveBadgeCircle":"LiveBadge_liveBadgeCircle___JCOk"};